import React, { useContext, useEffect, useState } from 'react';
import { Routes as RouterRoutes, Route, Navigate } from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';
import PublicRoutes from './PublicRoutes';
import OpenRoutes from './OpenRoutes';
import {
  protectedRoutes,
  publicRoutes,
  authRoutes,
} from '../configs/RouteConfig';
import { AUTHENTICATED_ENTRY } from '../configs/AppConfig';
import AppRoute from './AppRoute';
import { RootContext } from '../context/RootContext';
import { getFirstNavigation } from '../utils/RouteUtils/getFirstNavigation';

function Routes() {
  const [permission, setPermissions] = useState(
    JSON.parse(localStorage.getDecryptedItem('p_m__'))
  );

  const { p_m__ } = useContext(RootContext);
  useEffect(() => {
    setPermissions(JSON.parse(localStorage.getDecryptedItem('p_m__') || p_m__));
  }, [p_m__]);

  let checkPermissions = (checkValue) => {
    if (permission?.some((e) => e.name === checkValue)) {
      return true;
    } else {
      return false;
    }
  };

  const defaultFirstNav = getFirstNavigation(permission);
  return (
    <RouterRoutes>
      <Route path="/" element={<ProtectedRoutes />}>
        <Route
          path="/"
          element={<Navigate replace to={defaultFirstNav} />}
        />

        {protectedRoutes.map((route, index) => {
          const permissionName = route?.key;

          const hasAccessToRoute =
            permissionName === 'home' ||
            permissionName === 'change-password' ||
            checkPermissions(permissionName);

          return (
            <Route
              key={route.key + index}
              path={route.path}
              element={
                hasAccessToRoute ? (
                  <AppRoute
                    routeKey={route.key}
                    component={route.component}
                    {...route.meta}
                  />
                ) : (
                  <Navigate replace to={AUTHENTICATED_ENTRY} />
                )
              }
            />
          );
        })}

        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>

      <Route path="/" element={<PublicRoutes />}>
        {authRoutes.map((route) => {
          return (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
      <Route path="/" element={<OpenRoutes />}>
        {publicRoutes.map((route) => {
          return (
            <Route
              key={route.key}
              path={route.path}
              element={
                <AppRoute
                  routeKey={route.key}
                  component={route.component}
                  {...route.meta}
                />
              }
            />
          );
        })}
      </Route>
    </RouterRoutes>
  );
}

export default Routes;
